import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Campaign = forwardRef<SVGSVGElement, IconProps>(({ size = 32 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <g id="high-detailIcons">
        <path
          id="Union"
          d="M12.4005 21.4494C8.43678 20.7652 8.30453 16.06 8.80176 12.8C7.08615 14.9798 5.19834 16.0275 3.01875 17.2325C3.70524 18.4217 5.16333 22.3884 6.399 24.5288C8.14091 24.1421 10.0794 25.6629 11.101 28.6752C11.2767 29.1935 11.8068 29.5214 12.3393 29.3954L15.3042 28.694C15.956 28.5398 16.2057 27.8468 15.742 27.3634C14.9089 26.495 13.6731 25.3331 12.7499 24.5275C14.0882 23.7548 13.8076 21.8261 12.4005 21.4494Z"
          fill="#B3370F"
        />
        <path
          id="Vector 394"
          d="M7.01897 14.3787C8.79723 12.9223 9.21554 11.6266 10.7606 5.44719L15.9052 12.7425L21.0117 22.7108C16.3753 21.8083 13.4548 21.8875 13.4548 21.8875L6.52814 24.493C4.1625 25.2655 0.0910203 19.5042 2.92335 17.2834C2.92335 17.2834 5.24072 15.8351 7.01897 14.3787Z"
          fill="url(#paint0_linear_2383_1114)"
        />
        <g id="Ellipse 2212" filter="url(#filter0_d_2383_1114)">
          <ellipse
            cx="4.63473"
            cy="10.8144"
            rx="4.63473"
            ry="10.8144"
            transform="matrix(-0.866025 0.5 0.5 0.866025 15.9175 1.43396)"
            fill="url(#paint1_radial_2383_1114)"
          />
          <path
            d="M13.7301 15.1842C15.1977 17.7262 16.9569 19.7515 18.5957 20.9775C19.4158 21.5911 20.1857 21.9894 20.857 22.1646C21.5254 22.339 22.0603 22.2848 22.4681 22.0493C22.8758 21.8139 23.1902 21.3777 23.3734 20.7118C23.5573 20.0429 23.5973 19.1769 23.476 18.1598C23.2336 16.1276 22.3593 13.5914 20.8916 11.0495C19.424 8.50751 17.6648 6.48216 16.0261 5.25615C15.2059 4.64257 14.436 4.24423 13.7647 4.06909C13.0964 3.89472 12.5614 3.94892 12.1537 4.18434C11.7459 4.41976 11.4315 4.85593 11.2484 5.52192C11.0644 6.19082 11.0244 7.05677 11.1457 8.07383C11.3881 10.106 12.2625 12.6422 13.7301 15.1842Z"
            stroke="url(#paint2_radial_2383_1114)"
          />
        </g>
        <path
          id="Vector 395"
          d="M22.6401 9.991L26.4652 7.3361C26.9206 7.01997 27.549 7.16064 27.8262 7.64079C28.1035 8.12095 27.9111 8.73548 27.4096 8.97187L23.1978 10.957C22.9345 11.0811 22.6201 10.9827 22.4745 10.7306C22.329 10.4785 22.401 10.157 22.6401 9.991Z"
          fill="#FB6434"
        />
        <path
          id="Vector 396"
          d="M18.9829 5.78713L20.9681 1.57538C21.2045 1.07386 21.819 0.881492 22.2992 1.15871C22.7793 1.43592 22.92 2.06431 22.6039 2.51979L19.949 6.34486C19.783 6.58398 19.4614 6.65597 19.2094 6.51043C18.9573 6.36489 18.8588 6.05042 18.9829 5.78713Z"
          fill="#FB6434"
        />
        <path
          id="Vector 397"
          d="M24.8724 14.8722L29.5124 14.4856C30.065 14.4395 30.5388 14.8755 30.5388 15.43C30.5388 15.9844 30.065 16.4204 29.5124 16.3744L24.8724 15.9877C24.5823 15.9635 24.3592 15.721 24.3592 15.43C24.3592 15.1389 24.5823 14.8964 24.8724 14.8722Z"
          fill="#FB6434"
        />
        <path
          id="Intersect"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.2297 17.8917C15.5448 17.1044 14.8592 16.1438 14.2347 15.0622C13.759 14.2382 13.3618 13.4185 13.0495 12.6385C14.4837 11.9765 16.2121 12.5059 17.0173 13.9006C17.8007 15.2574 17.438 16.9614 16.2297 17.8917Z"
          fill="url(#paint3_radial_2383_1114)"
          fillOpacity="0.6"
        />
        <path
          id="Vector 614"
          d="M12.5795 21.5963C10.2943 20.6147 7.83209 16.2696 8.33097 14.1293L7.01136 15.304C7.01136 17.6536 8.86203 21.0975 11.0989 22.24C11.5281 22.0577 12.0001 21.8538 12.5795 21.5963Z"
          fill="black"
          fillOpacity="0.27"
        />
        <path
          id="Vector 615"
          d="M10.4265 22.5845C8.29691 21.6697 6.00234 17.6204 6.46725 15.6258L5.23748 16.7206C5.23748 18.9102 6.96216 22.1196 9.04677 23.1844C9.4467 23.0144 9.88661 22.8244 10.4265 22.5845Z"
          fill="black"
          fillOpacity="0.27"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_2383_1114"
          x="7.57629"
          y="3.46661"
          width="17.4691"
          height="23.3004"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="-1" dy="2" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.21 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2383_1114" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2383_1114" result="shape" />
        </filter>
        <linearGradient
          id="paint0_linear_2383_1114"
          x1="9.10299"
          y1="17.1225"
          x2="12.3859"
          y2="22.594"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FB6434" />
          <stop offset="1" stopColor="#982601" />
        </linearGradient>
        <radialGradient
          id="paint1_radial_2383_1114"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(8.23463 11.5773) rotate(-177.529) scale(6.71438 11.7897)"
        >
          <stop stopColor="#999999" />
          <stop offset="1" stopColor="white" />
        </radialGradient>
        <radialGradient
          id="paint2_radial_2383_1114"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(13.1908 3.41136) rotate(85.3828) scale(13.5943 5.82611)"
        >
          <stop stopOpacity="0.18" />
          <stop offset="1" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="paint3_radial_2383_1114"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(15.8626 14.6421) rotate(55.8997) scale(2.29633 1.43766)"
        >
          <stop stopColor="#7B7B7B" />
          <stop offset="1" />
        </radialGradient>
      </defs>
    </svg>
  )
})

export default Campaign
